<script>
import SignUpForm from '@phoenix/mixins/components/form/myAccount/SignUpForm';
import { defineAsyncComponent } from 'vue';
import SelectField from '@maison/components/form/fields/SelectField.vue';
import FormGroup from '@maison/components/form/FormGroup.vue';
import CheckboxField from '@maison/components/form/fields/CheckboxField.vue';
import TextField from '@maison/components/form/fields/TextField.vue';
import PasswordField from '@maison/components/form/fields/PasswordField.vue';

export default {
  components: {
    PasswordField,
    TextField,
    CheckboxField,
    FormGroup,
    SelectField,
    PhoenixForm: defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue')),
  },

  mixins: [SignUpForm],
};
</script>

<template>
  <phoenix-form
    v-if="shouldDisplayForm"
    ref="phoenixForm"
    v-model="fields"
    :action="formActionUrl"
    :custom-submit-text="$t('MyAccount.createMyAccount')"
    :should-display-submit-button="shouldDisplaySubmitButton"
    :on-success-callback="addTrackingInformation"
    :on-fail-callback="onFail"
    :show-errors-in-toast="showErrorsInToast"
    :redirect-url="redirectUrl"
    :terms-link="termsLink"
    data-cy="signup-form"
    form-type="accountCreation"
    korean-form-type="accountCreation"
    captcha-enabled
    prefill-enabled
    should-display-chinese-pipl-statement
    refresh-ping
  >
    <template #default="{ shouldDisplayNewsletter }">
      <div class="grid grid-cols-12 gap-4">
        <form-group v-if="fieldIsPresent('gender')" :attrs="fields.gender" class="col-span-12">
          <select-field v-model="fields.gender.value" />
        </form-group>

        <form-group v-if="fieldIsPresent('title')" :attrs="fields.title" class="col-span-12">
          <select-field v-model="fields.title.value" />
        </form-group>

        <form-group
          v-if="fieldIsPresent('firstName2') && isArabicLanguage"
          :attrs="fields.firstName2"
          class="col-span-12"
        >
          <text-field v-model="fields.firstName2.value" />
        </form-group>

        <form-group
          v-if="fieldIsPresent('lastName2') && isArabicLanguage"
          :attrs="fields.lastName2"
          class="col-span-12"
        >
          <text-field v-model="fields.lastName2.value" />
        </form-group>

        <form-group v-if="fieldIsPresent('firstName1')" :attrs="fields.firstName1" class="col-span-12">
          <text-field v-model="fields.firstName1.value" />
        </form-group>

        <form-group v-if="fieldIsPresent('lastName1')" :attrs="fields.lastName1" class="col-span-12">
          <text-field v-model="fields.lastName1.value" />
        </form-group>

        <form-group
          v-if="fieldIsPresent('firstName2') && !isArabicLanguage"
          :attrs="fields.firstName2"
          class="col-span-12"
        >
          <text-field v-model="fields.firstName2.value" />
        </form-group>

        <form-group
          v-if="fieldIsPresent('lastName2') && !isArabicLanguage"
          :attrs="fields.lastName2"
          class="col-span-12"
        >
          <text-field v-model="fields.lastName2.value" />
        </form-group>

        <form-group v-if="fieldIsPresent('email')" :attrs="fields.email" class="col-span-12">
          <text-field v-model="fields.email.value" />
        </form-group>

        <form-group v-if="fieldIsPresent('mobilePhone')" :attrs="fields.mobilePhone" class="col-span-12">
          <text-field v-model="fields.mobilePhone.value" />
        </form-group>

        <form-group :attrs="fields.password" class="col-span-12">
          <password-field v-model="fields.password.value" />
        </form-group>

        <form-group :attrs="fields.passwordConfirmation" class="col-span-12">
          <password-field v-model="fields.passwordConfirmation.value" />
        </form-group>

        <form-group v-if="shouldDisplayNewsletter" :show-label="false" :attrs="fields.newsletter" class="col-span-12">
          <checkbox-field v-model="fields.newsletter.value" />
        </form-group>
      </div>
    </template>
  </phoenix-form>
</template>
